import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function PageHero({ eyebrow, title, subtitle, breadcrumb }) {
  return (
    <section className="relative overflow-hidden isolate">
      <div className="absolute inset-0 bg-gradient-to-br from-[#06182C] via-[#0A2540] to-[#0F766E]" />
      <div className="absolute inset-0 dotted-bg opacity-30" />
      <div className="container-x relative z-10 py-16 md:py-20">
        <div className="flex items-center gap-1.5 text-xs text-slate-300 mb-5">
          <Link to="/" className="flex items-center gap-1 hover:text-teal-light"><Home size={12} /> Home</Link>
          {breadcrumb?.map((b, idx) => (
            <React.Fragment key={idx}>
              <ChevronRight size={12} />
              {b.to ? (
                <Link to={b.to} className="hover:text-teal-light">{b.label}</Link>
              ) : (
                <span className="text-teal-light">{b.label}</span>
              )}
            </React.Fragment>
          ))}
        </div>
        {eyebrow && (
          <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-teal-light mb-3">
            <span className="w-6 h-px bg-current" /> {eyebrow}
          </span>
        )}
        <h1 className="text-white text-4xl md:text-5xl lg:text-[50px] font-bold tracking-tight leading-[1.1] max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-5 text-slate-200/90 text-lg max-w-3xl leading-relaxed">{subtitle}</p>
        )}
      </div>
    </section>
  );
}
